<template>
  <div v-if="hashtags.length" class="flex">
    <a
      v-for="hashtag in hashtags"
      :key="hashtag.id"
      :href="hashtag.route"
      class="hover:text-link-primary text-[#306aff] font-medium text-sm relative z-2 block"
      @click.stop
    >
      {{ getHashtagName(hashtag.name) }}
    </a>
  </div>
</template>
<script>
import { defineComponent, inject, computed } from '@nuxtjs/composition-api';
import { truncate } from 'lodash';
export default defineComponent({
  props: {
    truncate: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const article = inject('article', null);
    const hashtags = computed(() => article?.hashtags || []);
    const getHashtagName = (name) => (props.truncate ? truncate(name, { length: 18 }) : name);
    return { hashtags, getHashtagName };
  },
});
</script>
